import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://www.ia-schedule.com:4139/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  }
});

apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  response => response,
  error => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      localStorage.removeItem('token');
      localStorage.removeItem('user');

      const alertMessage = {
        title: 'Session Expired',
        description: 'Your session has expired. Please log in again.',
        variant: 'warning'
      };
      sessionStorage.setItem('auth_redirect_message', JSON.stringify(alertMessage));

      window.location.href = '/';
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default apiClient;